import ActivityContainer from './Activity.container';

export default ActivityContainer;
